import React, { useEffect, useState } from "react";
import RoleToggle from "../../components/RoleToggle";
import TicketsTab from "./_components/TicketsTab";
import PermissionGuard from "../../components/PermissionGuard";
// import ChatSupportListTab from "./_components/ChatSupportListTab";

const HelpandSupport: React.FC = () => {
  const roles = ["Tickets Support"/* , "Chat Support" */];

  const [activeRole, setActiveRole] = useState<string>(() => {
    const saved = localStorage.getItem("HelpSupportActiveRole");
    return saved && roles.includes(saved) ? saved : roles[0];
  });
  useEffect(() => {
    localStorage.setItem("HelpSupportActiveRole", activeRole);
  }, [activeRole]);

  return (
    <PermissionGuard module="tickets" action="read">
      <div className="p-6 pt-0 space-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl text-[#212121] tracking-[-0.5px] ">
            Help & Support
          </h1>
          <RoleToggle
            options={roles}
            active={activeRole}
            onChange={setActiveRole}
          />
        </div>

        {activeRole === "Tickets Support" ? <TicketsTab /> : null}
        {/* {activeRole === "Chat Support" ? <ChatSupportListTab /> : null} */}
      </div>
    </PermissionGuard>
  );
};

export default HelpandSupport;
